import { Instance } from 'mobx-state-tree'
import { UserStreakResponseModelBase } from './UserStreakResponseModel.base'

/* The TypeScript type of an instance of UserStreakResponseModel */
export interface UserStreakResponseModelType extends Instance<typeof UserStreakResponseModel.Type> {}

/* A graphql query fragment builders for UserStreakResponseModel */
export {
  selectFromUserStreakResponse,
  userStreakResponseModelPrimitives,
  UserStreakResponseModelSelector
} from './UserStreakResponseModel.base'

/**
 * UserStreakResponseModel
 */
export const UserStreakResponseModel = UserStreakResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
